import { snakeCase } from 'lodash';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { humanise } from 'components/atoms/humanised-date';
import { DateField } from 'components/organisms/tasks/fields';
import {
  DateFieldAbsoluteFilter,
  DateFieldFilter,
  DateFieldFilterAbsoluteOperationTypes,
  DateFieldFilterOperationType,
  DateFieldFilterOperationTypes,
  DateFieldFilterOptionalOperationTypes,
} from 'components/organisms/tasks/filters/date';

const SelectedOptionRenderer = ({ filter }: { filter: DateFieldFilter }) => (
  <FormattedMessage
    id={`settings.integrations.sf.trigger.option.selected.${snakeCase(
      DateFieldFilterOperationType[filter.type],
    )}`}
    values={{
      format: humanise((filter as DateFieldAbsoluteFilter).value ?? moment()),
    }}
  />
);

export const dateTriggerOptionRenderers = (
  operationType: DateFieldFilterOperationType,
  filter?: DateFieldFilter,
): null | JSX.Element => {
  switch (operationType) {
    case DateFieldFilterOperationType.IsOn: {
      if (filter) {
        return <SelectedOptionRenderer filter={filter} />;
      }

      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_on" />
      );
    }

    case DateFieldFilterOperationType.IsAfter: {
      if (filter) {
        return <SelectedOptionRenderer filter={filter} />;
      }

      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_after" />
      );
    }

    case DateFieldFilterOperationType.IsBefore: {
      if (filter) {
        return <SelectedOptionRenderer filter={filter} />;
      }

      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_before" />
      );
    }

    case DateFieldFilterOperationType.IsEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_empty" />
      );
    }

    case DateFieldFilterOperationType.IsNotEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_not_empty" />
      );
    }

    default: {
      return null;
    }
  }
};

const availabletriggerFilters = [
  ...DateFieldFilterOptionalOperationTypes,
  ...DateFieldFilterAbsoluteOperationTypes,
];
const validDateTriggerFilters = (type: DateFieldFilterOperationType): boolean =>
  availabletriggerFilters.includes(type);

export const dateFilterOperationOptions = (field: DateField) =>
  DateFieldFilterOperationTypes.filter((x) => validDateTriggerFilters(x)).map(
    (type) =>
      ({
        field,
        type,
      } as any as DateFieldFilter),
  );
